















import { Component, Vue, Prop } from "vue-property-decorator";
import { UploadImg, getUserInfo } from "@/req/user";
import cropImage from "./cropImage.vue";
@Component({
  components: {
    cropImage,
  },
})
export default class Home extends Vue {
  @Prop({ type: Number, default: -1 }) public recommendActive;
  public async submit() {
    const $cropImage: any = this.$refs.cropImage;
    if (!$cropImage.imageButton) {
      return this.$Message.error("未上传图片");
    }
    // console.log($cropImage.imageUrl)
    this.$emit("submitAvator", 1, $cropImage.imageUrl);
    /* const res = await UploadImg({
      token: this.$fn.cookies.getToken("token"),
      file: $cropImage.imageUrl,
    });
    if (res.code === 200) {
      this.$Message.success(res.msg);
      this.$emit("getUserInfo");
    } */
  }
  public mounted() {
    if (this.recommendActive === null) {
      const imgUrl = this.$store.state.user.info.head_img;
      const $cropImage: any = this.$refs.cropImage;
      $cropImage.getBase64Image(imgUrl);
    }
  }
}
